import request from '@/utils/request';
export function overview(data) {
  return request({
    url: '/app-upload-monitor/overview',
    method: 'get',
    data: data
  });
}